import { UserRoles } from "./enums";
export const isAuthorizedUser = (roles) => {
    const authorizedRoles = [UserRoles.PdfServiceUser];
    const arrayIntersection = authorizedRoles.filter(item => roles.indexOf(item) !== -1);
    return Boolean(arrayIntersection.length);
};
